import { useIntl } from 'react-intl';

import { DownloadableDocument } from '../DownloadableDocument';

import { ReactComponent as UserManual } from '@/assets/icons/userManual.svg';

import * as M from '../../messages';

type PropsType = {
  downloadUrl: string;
};

export const DownloadableUserManual = ({ downloadUrl }: PropsType) => {
  const { formatMessage } = useIntl();

  return (
    <DownloadableDocument
      Svg={UserManual}
      data-test-id='DownloadableUserManual'
      href={downloadUrl ?? ''}
      text={formatMessage(M.messages.userManual)}
    />
  );
};

DownloadableUserManual.displayName = 'DownloadableUserManual';
